import { getCurrentCulture } from "@utils";

const setWorkingHours = (from: number, to: number) => {
	const timeFrom = new Date();
	timeFrom.setHours(from, 0, 0, 0);

	const timeTo = new Date();
	timeTo.setHours(to, 0, 0, 0);

	return {
		from: timeFrom.toLocaleTimeString(getCurrentCulture(), {
			hour: "2-digit",
			minute: "2-digit",
		}),
		to: timeTo.toLocaleTimeString(getCurrentCulture(), {
			hour: "2-digit",
			minute: "2-digit",
		}),
	};
};

export const workingHours = setWorkingHours(11, 20);
